// src/components/AddAreaModal.js
import React, { useState } from 'react';
import { API_URL } from "../config";

function AddAreaModal({ onClose, onSave }) {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) {
      setError('Nazwa obszaru jest wymagana');
      return;
    }
    try {
      const response = await fetch(`${API_URL}/areas`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ name, description }),
      });
      if (!response.ok) throw new Error('Błąd dodawania obszaru');
      onSave();
      onClose();
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h3>Dodaj Nowy Obszar</h3>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Nazwa obszaru"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
          <input
            type="text"
            placeholder="Opis (niewymagane)"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
          {error && <p style={{ color: 'red' }}>{error}</p>}
          <div className="modal-buttons">
            <button type="submit" className="btn-submit">Zapisz</button>
            <button type="button" className="btn-submit" onClick={onClose}>Anuluj</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddAreaModal;